import { render, staticRenderFns } from "./BlogHighlightsCard.vue?vue&type=template&id=7bdfaba1&"
import script from "./BlogHighlightsCard.vue?vue&type=script&lang=js&"
export * from "./BlogHighlightsCard.vue?vue&type=script&lang=js&"
import style0 from "./BlogHighlightsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports